import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { useStore } from '@data/other/withStore';
import { getPageFromRoute, Routes as AppRoutes } from '@view/routes';
import { useIsExternalPaymentSystemEnabled } from './useExternalPaymentSystem';
export const useApplicationFlow = () => {
    var _a, _b;
    const { components: { searchPanel: { value: searchPanelValue }, }, property, } = useStore();
    const { pathname } = useLocation();
    const { isUsingExternalPaymentSystem } = useIsExternalPaymentSystemEnabled();
    const displayAddons = useMemo(() => { var _a, _b; return ((_b = (_a = property.model) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.displayAddons) || 'preCheckout'; }, [(_b = (_a = property.model) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.displayAddons]);
    const selectAddonsBeforePayment = useMemo(() => displayAddons === 'preCheckout', [displayAddons]);
    const selectAdonsOnConfirmationPage = useMemo(() => displayAddons === 'postCheckout', [displayAddons]);
    const routeOrder = useMemo(() => {
        const paymentRoute = isUsingExternalPaymentSystem
            ? []
            : [AppRoutes.Payment];
        if (displayAddons === 'preCheckout') {
            return [
                AppRoutes.Accommodations,
                AppRoutes.Addons,
                AppRoutes.Guests,
                ...paymentRoute,
                AppRoutes.Confirmation,
            ];
        }
        return [
            AppRoutes.Accommodations,
            AppRoutes.Guests,
            ...paymentRoute,
            AppRoutes.Confirmation,
        ];
    }, [displayAddons, isUsingExternalPaymentSystem]);
    const currentRoute = useMemo(() => {
        const endPath = pathname.split('/').slice(-1)[0];
        return (routeOrder.find((page) => page === endPath) || AppRoutes.Accommodations);
    }, [pathname, routeOrder]);
    const currentPage = useMemo(() => {
        const isLandingPage = currentRoute === AppRoutes.Accommodations &&
            !searchPanelValue.checkin &&
            !searchPanelValue.checkout;
        if (isLandingPage) {
            return 'Landing';
        }
        return getPageFromRoute(currentRoute);
    }, [currentRoute, searchPanelValue.checkin, searchPanelValue.checkout]);
    const nextRoute = useMemo(() => {
        const index = routeOrder.indexOf(currentRoute);
        if (index < routeOrder.length - 1) {
            return routeOrder[index + 1];
        }
        return AppRoutes.Accommodations;
    }, [currentRoute, routeOrder]);
    const previousRoute = useMemo(() => {
        const index = routeOrder.indexOf(currentRoute);
        if (index > 0) {
            return routeOrder[index - 1];
        }
        return AppRoutes.Accommodations;
    }, [currentRoute, routeOrder]);
    return {
        currentPage,
        currentRoute,
        displayAddons,
        nextRoute,
        pathname,
        previousRoute,
        selectAddonsBeforePayment,
        selectAdonsOnConfirmationPage,
    };
};
